module.exports = __webpack_public_path__ + "img/guards3.11ca39c3.jpg";